@if (labelMode() === 'fixed' && label()) {
  <label
    for="multi-select-input"
    class="block mb-2 text-sm font-medium text-gray-700"
    [class.opacity-60]="isDisabled()"
    [class.cursor-not-allowed]="isDisabled()">
    {{ label() }}
    @if (hasRequiredRule()) {
      <span class="ml-0.5 text-red-500">*</span>
    }
  </label>
}

@if (useFloatLabel()) {
  <p-floatlabel class="w-full">
    <ng-container *ngTemplateOutlet="multiSelectTemplate"></ng-container>
    <label for="multi-select-input">
      {{ label() }}
      @if (hasRequiredRule()) {
        <span class="ml-0.5 text-red-500">*</span>
      }
    </label>
  </p-floatlabel>
} @else if (useIftaLabel()) {
  <p-iftalabel class="w-full">
    <ng-container *ngTemplateOutlet="multiSelectTemplate"></ng-container>
    <label for="multi-select-input">
      {{ label() }}
      @if (hasRequiredRule()) {
        <span class="ml-0.5 text-red-500">*</span>
      }
    </label>
  </p-iftalabel>
} @else {
  <ng-container *ngTemplateOutlet="multiSelectTemplate"></ng-container>
}

<ng-template #multiSelectTemplate>
  <p-multiSelect
    id="multi-select-input"
    class="w-full"
    [options]="availableOptions()"
    [(ngModel)]="selected"
    [optionLabel]="OPTION_LABEL"
    [optionValue]="optionValue()"
    [optionDisabled]="OPTION_DISABLED"
    [optionGroupLabel]="optionGroupLabel()"
    [optionGroupChildren]="optionGroupChildren()"
    [group]="group()"
    [placeholder]="placeholder()"
    [variant]="variant()"
    [showClear]="showClear()"
    [disabled]="isDisabled()"
    [filter]="filterEnabled()"
    [filterBy]="FILTER_BY"
    [filterPlaceHolder]="filterPlaceholder()"
    [filterMatchMode]="filterMatchMode()"
    [autofocusFilter]="false"
    [focusOnHover]="focusOnHover()"
    [selectOnFocus]="selectOnFocus()"
    [autoOptionFocus]="autoOptionFocus()"
    [virtualScroll]="virtualScroll()"
    [virtualScrollItemSize]="VIRTUAL_SCROLL_ITEM_SIZE"
    [lazy]="lazy()"
    [loading]="isLoading()"
    [display]="display()"
    [showToggleAll]="showToggleAll()"
    [maxSelectedLabels]="maxSelectedLabels()"
    [selectedItemsLabel]="selectedItemsLabel()"
    [selectionLimit]="selectionLimit()"
    [invalid]="isInvalid()"
    (onChange)="handleChange($event)"
    (onFilter)="handleFilter($event)"
    (onFocus)="handleFocus($event)"
    (onBlur)="handleBlur($event)"
    (onClear)="handleClear()"
    (onSelectAllChange)="handleSelectAllChange($event)"
    (onLazyLoad)="handleLazyLoad($event)"
    [appendTo]="appendTo()">

    @if (optionTemplate(); as tmpl) {
      <ng-template pTemplate="option" let-option let-index="index">
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ $implicit: option, index: index }"
        ></ng-container>
      </ng-template>
    }

    @if (selectedItemsTemplate(); as tmpl) {
      <ng-template pTemplate="selectedItems" let-selectedOptions>
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ $implicit: selectedOptions }"
        ></ng-container>
      </ng-template>
    }

    @if (groupTemplate(); as tmpl) {
      <ng-template pTemplate="group" let-group>
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ $implicit: group }"
        ></ng-container>
      </ng-template>
    }

    @if (headerTemplate(); as tmpl) {
      <ng-template pTemplate="header">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (footerTemplate(); as tmpl) {
      <ng-template pTemplate="footer">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (emptyTemplate(); as tmpl) {
      <ng-template pTemplate="empty">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (loaderTemplate(); as tmpl) {
      <ng-template pTemplate="loader">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (filterTemplate(); as tmpl) {
      <ng-template pTemplate="filter" let-options="options">
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ options: options }"
        ></ng-container>
      </ng-template>
    }

    @if (clearIconTemplate(); as tmpl) {
      <ng-template pTemplate="clearicon">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (dropdownIconTemplate(); as tmpl) {
      <ng-template pTemplate="dropdownicon">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
      </ng-template>
    }

    @if (headerCheckboxIconTemplate(); as tmpl) {
      <ng-template pTemplate="headercheckboxicon" let-allSelected="allSelected">
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ allSelected: allSelected }"
        ></ng-container>
      </ng-template>
    }

    @if (itemCheckboxIconTemplate(); as tmpl) {
      <ng-template pTemplate="itemcheckboxicon" let-selected="selected">
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ selected: selected }"
        ></ng-container>
      </ng-template>
    }

    @if (chipTemplate(); as tmpl) {
      <ng-template pTemplate="chip" let-value="value">
        <ng-container
          [ngTemplateOutlet]="tmpl"
          [ngTemplateOutletContext]="{ $implicit: value }"
        ></ng-container>
      </ng-template>
    }
  </p-multiSelect>
</ng-template>

@if (showErrorMessage() && isInvalid() && errorMessage()) {
  <small class="multi-select-input__error block mt-1 ml-2 text-xs text-red-500">
    {{ errorMessage() }}
  </small>
}
